// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"AboutSectionSmallCard-module_cardContainer_fe58b","close":"AboutSectionSmallCard-module_close_c5485"};